import { router } from '@/router'
import { isInWeChatMiniProgram } from '@/utils/tool'
import { openSchemeForInstallCheck, removeSchemeIframe } from './appSchemeOpen'
import { buildAppSchemeUrl } from './appSchemeUrl'

// 检测是否为微信环境
const isWeChat = () => {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}

// 插入微信引导蒙层
function insertWeChatGuideMask() {
  if (document.getElementById('wechat-guide-mask')) return
  const mask = document.createElement('div')
  mask.id = 'wechat-guide-mask'
  mask.style.cssText = `
    position: fixed;z-index:999999;left:0;top:0;right:0;bottom:0;
    background: rgba(0,0,0,0.7);display: flex;align-items: flex-start;justify-content: flex-end;`

  /**
   * obs 静态资源基础路径由环境变量控制（见 .env.*）
   */
  const obsAssetsBaseUrl = import.meta?.env?.VITE_OBS_ASSETS_BASE_URL || 'https://ts-static.ourtour.com/obs/assets/'

  mask.innerHTML = `
    <div style="margin:30px 20px 0 0;text-align:right;">
      <img src='${obsAssetsBaseUrl}new-journey/icon_arrow.png' style='width:60px;height:60px;animation:arrow-move 1s infinite alternate;' />
      <div style='color:#fff;font-size:18px;margin-top:10px;line-height:1.6;text-shadow:0 2px 8px #000;'>
        请点击右上角 <b>···</b>，<br />选择 <b>在浏览器中打开</b>
      </div>
    </div>
    <style>@keyframes arrow-move{0%{transform:translateY(0);}100%{transform:translateY(-10px);}}</style>
  `
  mask.onclick = () => document.body.removeChild(mask)
  document.body.appendChild(mask)
}

/**
 * 检测是否为Safari浏览器
 * @returns {boolean} 如果是Safari浏览器则返回 true，否则返回 false
 */
const isSafari = () => {
  const ua = navigator.userAgent.toLowerCase()
  return /safari/.test(ua) && !/chrome/.test(ua) && !/chromium/.test(ua)
}

/**
 * 检测APP是否安装的函数（原生浏览器用）
 * @param {string} scheme - 自定义URL scheme
 * @returns {Promise<boolean>} 如果APP已安装则返回 true，否则返回 false
 */
const checkAppInstalled = scheme => {
  return new Promise(resolve => {
    const isSafariBrowser = isSafari()
    const timeout = 1000
    
    let hasResolved = false
    let appOpened = false
    let iframe = null

    const handle = () => {
      appOpened = true
      cleanup()
      if (!hasResolved) {
        hasResolved = true
        resolve(true)
      }
    }
    
    const cleanup = () => {
      window.removeEventListener('blur', handle)
      document.removeEventListener('visibilitychange', handle)
      removeSchemeIframe(iframe)
    }
    
    // 添加事件监听
    window.addEventListener('blur', handle)
    document.addEventListener('visibilitychange', handle)
    
    iframe = openSchemeForInstallCheck(scheme, { isSafariBrowser })
    
    // 设置超时
    setTimeout(() => {
      cleanup()
      if (!hasResolved) {
        hasResolved = true
        resolve(appOpened)
      }
    }, timeout)
  })
}

// 微信环境打开APP的方法
const openAppInWeChat = url => {
  insertWeChatGuideMask()
  return Promise.resolve(false)
}

export async function jumpToApp(url, isInDownload = false) {
  try {
    if (isWeChat()) {
      if (isInWeChatMiniProgram()) {
        router.push({
          path: '/newJourneyGift',
          query: {
            isNoticeToApp: '1',
          },
        })
        return
      }
      await openAppInWeChat(url)
      // 不再跳转APP，直接引导
      return
    } else {
      const schemeUrl = buildAppSchemeUrl(url)
      const isInstalled = await checkAppInstalled(schemeUrl)
      if (!isInstalled) {
        if (isInDownload) {
          return Promise.resolve(false)
        }
        router.push(`/download${url?.includes('isOpen=1') ? '?isOpen=1' : ''}`)
      } else {
        return Promise.resolve(true)
      }
    }
  } catch (error) {
    console.error('检测APP安装状态失败:', error)
    router.push(`/download${url?.includes('isOpen=1') ? '?isOpen=1' : ''}`)
  }
}
